import editablefieldtpl from './editable-field.tpl.html';

export class EditableField {
  $onInit() {
    this.editMode = false;
    this.isEditable = !this.isReadOnly;
  }

  $onChanges(changesObj) {
    this.editableModel = changesObj.editableModel.currentValue;
  }

  save() {
    this.onSave({ editableModel: this.editableModel });
  }

  handleEditClick() {
    this.editMode = !this.editMode;
    if (!this.editMode) {
      this.save();
    }
  }
}

export const editableField = {
  template: editablefieldtpl,
  controller: EditableField,
  bindings: {
    editableModel: '<',
    onSave: '&',
    isReadOnly: '<',
  },
};
